(() => {
  if (window.SlabHubCard3D) return;
  const productPage = /\/products\//.test(location.pathname);
  const states = new Map(), queue = [], activeLoads = new Set();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(pointer: coarse)').matches;
  let libraryPromise, editing = false, typingUntil = 0, typingTimer;
  const home = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(location.pathname);
  const reveals = new Set(); let revealFrame;
  /* velocita' variabile: lenta sul fronte, veloce sul retro (richiesta Valerio) */
  const spinning = new Set(); let spinFrame;
  const introActive = () => document.documentElement.matches('.sh-boot,.sh-intro-on');
  const newsletterReady = () => window.SlabHubNewsletter?.phase === 'ready';
  /* loadable: la cornice puo' caricare (anche durante l'intro); eligible: puo' anche girare. */
  const loadable = state => state.wrapper.isConnected && (!productPage || !state.wrapper.hidden) && state.visible && !document.hidden &&
    (!editing || !!state.wrapper.closest('predictive-search'));
  const eligible = state => loadable(state) && !introActive();
  function baseSpeed(state) {
    if (state.baseSpeed == null) {
      const attr = parseFloat(state.viewer.getAttribute('rotation-per-second'));
      state.baseSpeed = Number.isFinite(attr) && attr > 0 ? attr : 30;
    }
    return state.baseSpeed;
  }
  function spinTick() {
    spinFrame = null;
    for (const state of spinning) {
      if (!state.viewer.hasAttribute('auto-rotate')) { spinning.delete(state); continue; }
      const a = state.viewer.turntableRotation || 0;
      /* 0 sul fronte, 1 a retro pieno; curva morbida senza scatti */
      const back = Math.pow((1 - Math.cos(a)) / 2, 2);
      const speed = Math.round(baseSpeed(state) * (0.55 + 2.2 * back));
      if (speed !== state.lastSpeed) { state.viewer.rotationPerSecond = speed + 'deg'; state.lastSpeed = speed; }
    }
    if (spinning.size) spinFrame = requestAnimationFrame(spinTick);
  }
  function setSpinning(state, on) {
    if (on) { spinning.add(state); if (!spinFrame) spinFrame = requestAnimationFrame(spinTick); }
    else spinning.delete(state);
  }
  function resetFront(state) {
    reveals.delete(state); state.revealDone = !home;
    state.viewer.removeAttribute('auto-rotate'); setSpinning(state, false);
    state.viewer.resetTurntableRotation?.(home ? -55 * Math.PI / 180 : 0);
    state.viewer.cameraOrbit = '0deg 80deg auto';
    state.viewer.jumpCameraToGoal?.();
    state.viewer.autoRotateDelay = 900;
  }
  function revealTick(now) {
    revealFrame = null;
    for (const state of reveals) {
      if (!eligible(state) || !newsletterReady() || editing || state.interacted) {reveals.delete(state);continue}
      const t=Math.max(0,Math.min(1,(now-state.revealStart)/1800));
      state.viewer.resetTurntableRotation(state.revealFrom*Math.pow(1-t,3));
      if (t===1) {reveals.delete(state);state.revealDone=true;updateRotation(state)}
    }
    if (reveals.size) revealFrame=requestAnimationFrame(revealTick);
  }
  function updateRotation(state) {
    const allowed=eligible(state) && state.loaded && newsletterReady() && !editing && !state.interacted && !reducedMotion.matches && (!productPage || state.wrapper.dataset.paused !== 'true');
    if (allowed && home && !state.revealDone) {
      state.viewer.removeAttribute('auto-rotate'); setSpinning(state, false);
      if (!reveals.has(state)) {
        state.revealStart=performance.now();state.revealFrom=state.viewer.turntableRotation;
        reveals.add(state);if (!revealFrame) revealFrame=requestAnimationFrame(revealTick);
      }
    } else {
      reveals.delete(state);
      state.viewer.toggleAttribute('auto-rotate',allowed);
      setSpinning(state, allowed);
    }
  }
  function release(state, snapshot = true) {
    reveals.delete(state); setSpinning(state, false);
    clearTimeout(state.releaseTimer);
    if (activeLoads.has(state)) { state.releaseWhenLoaded = true; return; }
    if (snapshot && state.loaded && !state.snapshot) {
      try {
        const img = document.createElement('img');
        img.className = 'slab-model-snapshot'; img.alt = ''; img.setAttribute('aria-hidden', 'true');
        img.src = state.viewer.toDataURL('image/webp', .94);
        state.wrapper.append(img); state.snapshot = img;
      } catch (_) {}
    }
    state.viewer.removeAttribute('auto-rotate');
    delete state.wrapper.dataset.loaded;
    state.viewer.src = null;
    state.loaded = state.started = state.queued = false;
    state.releaseWhenLoaded = false;
    state.interacted = false;
  }
  function scheduleRelease(state) {
    clearTimeout(state.releaseTimer);
    state.releaseTimer = setTimeout(() => {
      if (!loadable(state)) release(state);
    }, 1000);
  }
  function pump() {
    if (document.hidden) return;
    const intro = introActive();
    if (performance.now() < typingUntil) {
      clearTimeout(typingTimer); typingTimer = setTimeout(pump, typingUntil - performance.now() + 20); return;
    }
    queue.sort((a,b) => {
      const score = s => s.wrapper.closest('.slab-product-model') ? -10000 : Math.abs(s.wrapper.getBoundingClientRect().top);
      return score(a) - score(b);
    });
    /* durante l'intro si precarica una sola cornice, cosi' parte subito dopo */
    while (activeLoads.size < (intro || mobile ? 1 : 2) && queue.length) {
      if (intro && [...states.values()].some(s => s.loaded)) break;
      const state = queue.shift(); state.queued = false;
      if (!state.wrapper.isConnected || !loadable(state) || state.loaded) { state.started = false; continue; }
      activeLoads.add(state);
      state.viewer.src = (state.viewer.dataset.sourceQuality === 'hd' ? null : window.SlabHubCatalogModels?.[state.viewer.dataset.productHandle]) || state.viewer.dataset.src;
    }
  }
  function ensureLibrary() {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (libraryPromise) return libraryPromise;
    libraryPromise = new Promise((resolve, reject) => {
      const existing = [...document.scripts].find(s => /(?:^|\/)model-viewer(?:\.min)?\.js(?:[?#]|$)/.test(s.src));
      const script = existing || document.createElement('script');
      const timer = setTimeout(() => reject(new Error('Model viewer unavailable')), 30000);
      script.addEventListener('error', () => { clearTimeout(timer); reject(new Error('Model viewer unavailable')); }, {once:true});
      customElements.whenDefined('model-viewer').then(() => {
        clearTimeout(timer);
        // Retain live models only; scrolling must not accumulate decoded textures.
        const Viewer = customElements.get('model-viewer'); Viewer.modelCacheSize = 0;
        resolve();
      });
      if (!existing) {
        script.type = 'module'; script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
        document.head.append(script);
      }
    });
    return libraryPromise;
  }
  function start(state) {
    if (state.started || state.loaded || !loadable(state)) return;
    state.started = true;
    ensureLibrary().then(() => {
      if (state.wrapper.isConnected && !state.queued) { state.queued = true; queue.push(state); pump(); }
    }).catch(() => { state.started = false; state.wrapper.hidden = true; });
  }
  function sync() {
    for (const state of states.values()) {
      updateRotation(state);
      if (loadable(state)) { clearTimeout(state.releaseTimer); state.releaseWhenLoaded = false; start(state); }
      else scheduleRelease(state);
    }
    pump();
  }
  const visibility = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const state = states.get(entry.target); if (!state) continue;
      const arrived = entry.isIntersecting && !state.visible;
      state.visible = entry.isIntersecting;
      if (arrived && !state.interacted) resetFront(state);
      if (loadable(state)) { clearTimeout(state.releaseTimer); state.releaseWhenLoaded = false; start(state); }
      else scheduleRelease(state);
      updateRotation(state);
    }
  }, {rootMargin:'0px 0px 25% 0px',threshold:.01});
  function bind(wrapper) {
    if (states.has(wrapper)) return;
    const viewer = wrapper.querySelector('[data-slab-model]'); if (!viewer) return;
    const state = {wrapper,viewer,visible:false,loaded:false,started:false,queued:false,interacted:false};
    states.set(wrapper,state); viewer.removeAttribute('auto-rotate');
    viewer.addEventListener('load', () => {
      activeLoads.delete(state);
      state.loaded = true; state.started = false;
      state.wrapper.dataset.loaded='true';
      state.snapshot?.remove(); state.snapshot = null;
      const spinner = wrapper.querySelector('.slab-card-3d__loading'); if (spinner) spinner.hidden = true;
      resetFront(state);
      if (!loadable(state) || state.releaseWhenLoaded) release(state); else updateRotation(state);
      pump();
    });
    viewer.addEventListener('error', event => {
      activeLoads.delete(state); state.started = false;
      viewer.removeAttribute('auto-rotate'); setSpinning(state, false);
      wrapper.closest('.media')?.classList.add('slab-card-3d-failed');
      wrapper.hidden = true;
      if (event.detail?.type === 'webglcontextlost') {
        for (const other of states.values()) release(other, false);
      }
      pump();
    });
    viewer.addEventListener('camera-change', event => {
      if (event.detail?.source === 'user-interaction') { state.interacted = true; updateRotation(state); }
    });
    viewer.addEventListener('click', event => { if (viewer.closest('a')) event.preventDefault(); event.stopPropagation(); });
    visibility.observe(wrapper);
  }
  function scan(root = document) {
    if (root.matches?.('[data-slab-card-3d]')) bind(root);
    root.querySelectorAll?.('[data-slab-card-3d]').forEach(bind);
  }
  function cleanup() {
    for (const [wrapper,state] of states) if (!wrapper.isConnected) {
      visibility.unobserve(wrapper); activeLoads.delete(state); release(state,false); states.delete(wrapper);
    }
  }
  function changeModel(wrapper, src, handle) {
    scan(wrapper); const state = states.get(wrapper); if (!state) return;
    release(state); wrapper.hidden = false;
    state.viewer.dataset.src = src; state.viewer.dataset.productHandle = handle;
    resetFront(state); start(state);
  }
  window.SlabHubCard3D = {scan,changeModel,setPaused:(wrapper,paused)=>{const state=states.get(wrapper);if(!state)return;state.wrapper.dataset.paused=String(paused);if(!paused)state.interacted=false;updateRotation(state);},getStatus:() => ({
    bound:states.size,resident:[...states.values()].filter(s=>s.viewer.src).length,
    loaded:[...states.values()].filter(s=>s.loaded).length,loading:activeLoads.size,
    rotating:[...states.values()].filter(s=>s.viewer.hasAttribute('auto-rotate')).length,
    newsletter:window.SlabHubNewsletter?.phase,editing,intro:introActive()
  })};
  scan();
  document.addEventListener('shopify:section:load', event => {scan(event.target);sync()});
  new MutationObserver(records => {
    let removed = false;
    for (const record of records) {
      removed ||= record.removedNodes.length > 0;
      for (const node of record.addedNodes) if (node.nodeType === 1 && node.localName !== 'model-viewer') scan(node);
    }
    if (removed) cleanup();
  }).observe(document.documentElement,{childList:true,subtree:true});
  new MutationObserver(sync).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  document.addEventListener('slabhub:newsletter-state', () => {
    for (const state of states.values()) if (!state.interacted) resetFront(state);
    sync();
  });
  document.addEventListener('visibilitychange',() => {
    if (document.hidden) for (const state of states.values()) release(state);
    else sync();
  });
  reducedMotion.addEventListener('change',sync);
  document.addEventListener('focusin',event => {
    if (event.target.matches?.('input[type="search"],input[name="q"]')) {editing=true;sync()}
  });
  document.addEventListener('focusout',() => setTimeout(() => {
    editing=!!document.activeElement?.matches('input[type="search"],input[name="q"]');sync();
  },0));
  document.addEventListener('input',event => {
    if (event.target.matches?.('input[type="search"],input[name="q"]')) {
      typingUntil=performance.now()+700; clearTimeout(typingTimer); typingTimer=setTimeout(sync,720);
    }
  });
})();
